<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog" :visible="exportMark" width="500px" center >
      <div style="display:flex;justify-content: space-around;">
        <div>
          <el-table :data="tableList" ref="tableList" v-loading="loading"  center border height="600">
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column type="index" width="55" label="序号"></el-table-column>
            <el-table-column property="cnName" label="设置字段" width="300"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import { queryMyExportPageField } from '@/api/newTMS'
export default {
  name: 'tableheades',
  props: {
    // 缓存中记录每个页面的key
    groupCode: {
      type: String,
      default: null
    },
    exportMark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: '导出字段',
      tableList: [],
      loading: false,
      isXuanList: []
    }
  },
  mounted () {
    this.queryMyExportPageField()
  },
  methods: {
    // 查询要设置的字段表头
    queryMyExportPageField () {
      queryMyExportPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        // groupReport 集团收支报表
        // companyReport 分子公司收支报表
        // deptReport 部门收支报表
        tagCode: this.groupCode
      }).then(res => {
        this.tableList = res
        this.$nextTick(() => {
          for (let i = 0; i < this.tableList.length; i++) {
            this.$refs.tableList.toggleRowSelection(
              this.tableList[i],
              true
            )
          }
        })
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 确定
    confirm () {
      this.tableList.forEach(item => {
        let params = {
          name: item.cnName,
          key: item.enName,
          width: Math.round(item.fieldWidth / 8),
          isWrap: true,
          type: item.cnName == '三方网货单号' ? 1 : item.cnName == '收入发票号' || item.cnName == '支出发票号' ? 1 : 10
          // 根据数据类型 字符串传1  日期传4 数字是10
        }
        this.isXuanList.push(params)
      })
      // console.log(this.isXuanList,'this.isXuanList')
      this.$emit('exportList', this.isXuanList)
      this.$emit('update:exportMark', false)
    },
    closeDialog () {
      this.tableList = []
      this.$emit('update:exportMark', false)
    }
  }
}
</script>

<style scoped lang='less'>
.t_body {
  padding-left: 5px;
}
.current-row{
  color: #409eff;
}
</style>
